<p-dialog [visible]="visible" [modal]="true" [closable]="false" [closeOnEscape]="false" [draggable]="false" [resizable]="false"
  appendTo="body" styleClass="pc-dialog">
  <ng-template pTemplate="header">
    <div class="pc-head">
      <span class="p-dialog-title">Project contacts</span>
      <span class="pc-sub">{{ projectName }} · Project #{{ projectId }}@if (organizationName) { · {{ organizationName }} }</span>
    </div>
    <button type="button" class="pc-close" (click)="requestClose()" aria-label="Close">
      <i class="mdi mdi-close"></i>
    </button>
  </ng-template>

  <div class="pc-toolbar">
    <div class="pc-searchbox">
      <i class="mdi mdi-magnify pc-search-icon" aria-hidden="true"></i>
      <input type="text" id="pcSearch" class="form-control pc-search" autocomplete="off" aria-label="Search contacts"
        [placeholder]="loading ? 'Loading contacts…' : 'Search ' + (organizationName || 'organization') + ' contacts by name or email'"
        [disabled]="loading" [ngModel]="search" (ngModelChange)="onSearch($event)">
    </div>
    @if (locked) {
      <p class="pc-hint"><b>{{ staged.size }}</b> contacts on this project.</p>
    } @else {
      <p class="pc-hint"><b>{{ staged.size }}</b> of {{ totalContacts }} contacts on this project · tick a contact to add it, untick to remove it.</p>
    }
  </div>

  @if (loading) {
    <div class="pc-empty">Loading contacts&hellip;</div>
  } @else if (!rows.length) {
    <div class="pc-empty">
      <i class="mdi mdi-account-search-outline" aria-hidden="true"></i>
      @if (loadFailed) {
        <span>Contacts could not be loaded.</span>
      } @else if (search) {
        <span>No contacts match &ldquo;{{ search }}&rdquo;.</span>
      } @else {
        <span>This organization has no active contacts in Salesforce yet.</span>
      }
    </div>
  } @else {
    <ul class="pc-list" role="list" aria-label="Organization contacts">
      @for (contact of rows; track contact.contactId) {
        @let state = status(contact);
        @let checked = staged.has(contact.contactId);
        <li class="pc-row" [class.is-checked]="checked" [class.is-new]="state === 'new'" [class.is-removing]="state === 'removing'">
          <label class="pc-check" [class.is-hidden]="locked">
            <input type="checkbox" [disabled]="locked" class="form-check-input" [checked]="checked" (change)="toggle(contact)"
              [attr.aria-label]="(checked ? 'Remove ' : 'Add ') + contact.name + (checked ? ' from' : ' to') + ' this project'">
          </label>
          <span class="pc-avatar" aria-hidden="true">{{ initials(contact) }}</span>
          <span class="pc-person" (click)="toggle(contact)">
            <span class="pc-name-line">
              <span class="pc-name">{{ contact.name }}</span>
              @if (checked && isPrimary(contact)) { <span class="pc-tag is-primary">Primary</span> }
              @if (state === 'new') { <span class="pc-tag is-new">Adding</span> }
              @if (state === 'removing') { <span class="pc-tag is-removing">Removing</span> }
              @if (!contact.isActive) { <span class="pc-tag is-muted">Inactive</span> }
            </span>
            @if (contact.email) {
              <span class="pc-email-line">
                <span class="pc-email">{{ contact.email }}</span>
                <button type="button" class="pc-copy" [class.is-copied]="copiedId === contact.contactId"
                  (click)="$event.stopPropagation(); copyEmail(contact)" [attr.aria-label]="'Copy email ' + contact.email">
                  @if (copiedId === contact.contactId) { Copied! } @else { <i class="mdi mdi-content-copy"></i> }
                </button>
              </span>
            }
          </span>
          <span class="pc-row-actions">
            @if (!locked && checked && !isPrimary(contact)) {
              <button type="button" class="pc-link" (click)="setPrimary(contact)">Make primary</button>
            }
          </span>
        </li>
      }
    </ul>
  }

  <ng-template pTemplate="footer">
    <div class="pc-foot">
      @if (errorMessage) {
        <span class="pc-error" role="alert"><i class="mdi mdi-alert-circle-outline"></i> {{ errorMessage }}</span>
      } @else if (needsPrimary) {
        <span class="pc-warn"><i class="mdi mdi-alert-circle-outline"></i> Choose a primary contact</span>
      } @else if (!locked) {
        <span class="pc-summary">{{ summary || 'No changes' }}</span>
      }
      <div class="pc-actions">
        @if (locked) {
          <button type="button" class="btn btn-primary" (click)="requestClose()">Close</button>
        } @else {
          <button type="button" class="btn btn-light" (click)="requestClose()" [disabled]="saving">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving || needsPrimary || !pending.total">
            Save changes
            @if (saving) { <i class="fa fa-solid fa-sync fa-spin ms-1"></i> }
          </button>
        }
      </div>
    </div>
  </ng-template>
</p-dialog>

<app-confirmation-alert [showAlert]="showDiscardConfirm" message="Your contact changes haven’t been saved. Discard them?"
  (response)="onDiscardConfirm($event)"></app-confirmation-alert>
